import React from "react";

function OurCulture() {
  return (
    <section className="flex flex-col items-center w-full gap-10 sm:gap-0 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem]  montserrat bg-[#1C486B]">
      <div className="flex flex-col-reverse justify-center md:grid md:grid-cols-2">
        <div className="w-full max-w-3xl py-0 mx-auto my-auto text-white md:py-10 sm:px-12">
          <h2 className="text-left text-3xl sm:text-4xl font-extrabold text-[#FFF] my-4 sm:mt-10">
            Our Culture
          </h2>
          <p className="text-lg !leading-10">
            Continuous learning, collaboration, and a shared vision drive us
            forward. We are not just colleagues we are a community of
            sustainability champions shaping a better future.
          </p>
        </div>
        <div className="flex justify-center my-8 rounded-[12px]">
          <img
            src="/assets/images/Team/cultural-img.png"
            alt="Our Culture"
            className="w-full rounded-lg h-[380px] md:h-[480px]"
          />
        </div>
      </div>
    </section>
  );
}

export default OurCulture;
